import * as React from 'react';
import Link from 'next/link';

import PageBase from '../../components/layout/PageBase';

import styles from '../../styles/sass/pages/About.module.scss';
import track from '../../lib/track';
import { isMobile } from '../../lib/getDeviceSize';

export const About = () => {
  React.useEffect(() => {
    track.trackPage('About');
  }, []);

  return (
    <PageBase
      disableOverflow
      title="Buy or sell a home in Massachusetts | Real estate listings in Massachusetts | Torii"
    >
      <div
        className={`page-container ${styles.aboutUs} about-us row center-xs`}
      >
        {/* Section Hero */}
        <section className="col-xs-12 about-hero-banner">
          <img
            src={
              isMobile()
                ? '/static/img/about/about_heroImg-mobile.png'
                : '/static/img/about/about_heroImg-desktop.png'
            }
            alt="about_heroImg"
          />
        </section>

        <section className="<col-xs-12 section_head">
          <div className="container_wrap" style={{ marginTop: 45 }}>
            <h5 className="sub-heading">About</h5>
            <h2 className="section-heading">
              We're on a mission to reinvent the way people buy, sell, and own
              their home.
            </h2>
          </div>
        </section>

        {/*Section Alternate Image with Text block*/}
        <section className="col-xs-12 altImageText_block">
          <div className="container_wrap">
            <div className="feature_block topAlign mobi_reverse tab_reverse align_center">
              <div className="row">
                <span className="sub-text">
                  Building an easier <br className="no-desktop no-mobile" />{' '}
                  homebuying process <br />
                </span>
                <span className="text">
                  Torii was born out of frustration for an ineffectual and
                  archaic system. By combining innovative technology with a
                  better process powered by our passionate team, we've built the
                  easiest home buying experience around.
                </span>
              </div>
              <div className="image_wrap">
                <img
                  src={
                    isMobile()
                      ? '/static/img/about/homebuyProcess-mobile.png'
                      : '/static/img/about/homebuyProcess-desktop.png'
                  }
                  alt="Buy Process"
                />
              </div>
            </div>
            {/* Sell */}
            <div className="feature_block reverse bottomAlign mobi_reverse tab_reverse align_center">
              <div className="row">
                <span className="sub-text">We put your needs first</span>
                <span className="text">
                  Torii's team of industry experts is by your side through every
                  step of your home buying or selling journey. We provide you
                  with a dedicated Torii real estate to help with your search,
                  offer negotiation, and purchase, complete with a full support
                  team and everything you need to close on your perfect place
                </span>
              </div>
              <div className="image_wrap">
                <img
                  src={
                    isMobile()
                      ? '/static/img/about/homeSellProcess-mobile.png'
                      : '/static/img/about/homeSellProcess-desktop.png'
                  }
                  alt="Sell Process"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="col-xs-12 ourTeam_section pineGreen_bg">
          <div className="founders_block">
            <h2 className="titleHead">Meet the founders</h2>
            <div className="founder_container">
              <div className="founder_card">
                <img src="/static/img/about/james_new.png" alt="james" />
                <span className="name">James Rogers</span>
                <span className="role">ceo</span>
              </div>
              <div className="founder_card">
                <img src="/static/img/about/zach_new.png" alt="zach" />
                <span className="name">Zach Gorman</span>
                <span className="role">coo</span>
              </div>
            </div>
          </div>

          <div className="container_wrap">
            <h2 className="heading">Our Team</h2>
            <p className="mainText">
              Torii is a distributed team of people passionate about real estate
              and building innovative technology. Originally founded in Boston,
              our team has expanded across the globe.
            </p>
            <div className="btn_wrap">
              <Link href="/careers">
                <a className="btnHiring" rel="noopener noreferrer">
                  We’re hiring!
                </a>
              </Link>
            </div>
          </div>
        </section>

        <section className="col-xs-12 map_container">
          <img
            src={'/static/img/about/map-locations.png'}
            alt="map-locations"
          />
        </section>

        <section className="col-xs-12 press-container-wrap">
          <h2 className="section_title">Press</h2>
          <div className="col-xs-12 press-container press-container-about-page">
            <img
              src="/static/img/about/Business_Insider_Logo.svg"
              className="press-icon business-insider-icon"
              alt="Business-Insider"
            />
            <img
              src="/static/img/about/The_Boston_Globe.svg"
              className="press-icon boston-globe-icon"
              alt="Boston-Globe"
            />
            <img
              src="/static/img/about/inman-logo.svg"
              className="press-icon inman-icon"
              alt="Inman"
            />
          </div>
        </section>

        <section className="col-xs-12 blog_section">
          <h2 className="blog_section_title">Read more about us on our blog</h2>

          <div className="blog_cards_wrap">
            <div className="blog_card">
              <a
                href="https://blog.toriihomes.com/home-search-your-way/"
                target="_blank"
              >
                <img src="/static/img/about/blogImg_01.png" />
                <h3 className="blog_title">Home Search, Your Way</h3>
              </a>
            </div>

            <div className="blog_card">
              <a
                href="https://blog.toriihomes.com/introducing-the-torii-rebrand/"
                target="_blank"
              >
                <img src="/static/img/about/blogImg_02.png" />
                <h3 className="blog_title">Introducing the Torii Rebrand</h3>
              </a>
            </div>
            <div className="blog_card">
              <a
                href="https://blog.toriihomes.com/new-on-torii-home-buyers-dashboard/"
                target="_blank"
              >
                <img src="/static/img/about/blogImg_03.png" />
                <h3 className="blog_title">
                  New on Torii: Home Buyer’s Dashboard
                </h3>
              </a>
            </div>
          </div>
        </section>
      </div>
    </PageBase>
  );
};

export default About;
